export default {
  items: [
    {
      question: {
        en: 'Are these authentic scents?',
      },
      answer: {
        en: `
          Absolutely. Scentbird takes pride in offering only 100% authentic fragrances,
          which are provided to us directly from the brands and authorized vendors.
        `,
      },
    },
    {
      question: {
        en: 'What do I get?',
      },
      answer: {
        en: `
          30-day supply of any listed fragrances. Each month, we'll send you a 8 mL bottle of the fragrance you choose,
          which should last until the next scent arrives. Your first order will be sent with a white case for women's
          scents, or a matte black case for men's scents.
        `,
      },
    },
    {
      question: {
        en: 'Are there consequences if I cancel?',
      },
      answer: {
        en: `
          <p>
            Nope! If you need to cancel your membership, simply head to your account and hit the "Cancel Subscription"
            link under your Subscription Status menu.
          </p>
          <p>
            Make sure to cancel before the 3rd of the month, when your queue is
            locked for the billing cycle to take place on the 5th. We do not currently offer refunds for first-time
            shipments or renewed subscriptions.
          </p>
        `,
      },
    },
    {
      question: {
        en: 'When will I receive my perfume?',
      },
      answer: {
        en: `
          <p>We’ll email your tracking info over as soon as your order has shipped! Your tracking number is also accessible online from your Scentbird account.</p>
          <p>
            Your first Scentbird package should ship from our facility and arrive in your mailbox within 10 days of your subscription order.
            Just remember to choose your first scent within 12 hours of placing your order.
          </p>
        `,
      },
    },
    {
      question: {
        en: 'What if I can\'t find the scent I want?',
      },
      answer: {
        en: `
          <p>
            We're only giving a sneak peek of 72 scents before you subscribe, but after you sign up,
            you'll get access to the full catalog of over 600 scents that include brands like Versace,
            Gucci, Dolce & Gabbana, Burberry, and much more. You'll also be able to access skincare,
            and makeup as part of your subscription.
          </p>
          <p>
            Still can't find the scent you want? Let us know! We might be working on adding it,
            and our customer service team can help you find something similar we have in stock.
          </p>
        `,
      },
    },
  ],
}
